export default {
    namespaced: true,
    state: {
        page_size: 100,
        page_no: 1
    },
    mutations: {
        // ページナンバーをセット
        setPageNo(state, page_no) {
            state.page_no = page_no;
        },
        // ページサイズをセット
        setPageSize(state, page_size) {
            state.page_size = page_size;
        }
    },
    actions: {},
    getters: {
        // ページナンバーを取得
        getPageNo(state) {
            return state.page_no;
        },
        // ページサイズを取得
        getPageSize(state) {
            return state.page_size;
        }
    }
};
